import { render, staticRenderFns } from "./PageSizeSelector.vue?vue&type=template&id=4d2665a0&scoped=true"
import script from "./PageSizeSelector.vue?vue&type=script&lang=ts"
export * from "./PageSizeSelector.vue?vue&type=script&lang=ts"
import style0 from "./PageSizeSelector.vue?vue&type=style&index=0&id=4d2665a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2665a0",
  null
  
)

export default component.exports